// TODO 典拠検索、内容検索も順次追加する
import {
  defaultSearchCondition,
  SearchCondition
} from '@/pages/bibliographies/index.vue'
import { BibliographySearchHistory } from '@/api'
import {
  AloneSearchType,
  AuthoritySearchType,
  BibliographyClass,
  Prefix,
  SearchTarget,
  SearchType
} from '@/types'

export const loadingSearchHistory = (
  item: BibliographySearchHistory
): SearchCondition => {
  const searchCondition: SearchCondition = defaultSearchCondition()
  searchCondition.searchOption.searchTarget.input = item.searchTarget as SearchTarget
  searchCondition.searchOption.numberOfLimit.input = item.numberOfLimit as
    | 1000
    | 3000
    | 5000
    | 9999
  if (item.type === '1') {
    searchCondition.searchType = 'basic'
    searchCondition.searchOption.displayMethod.input = item.displayMethod as
      | '1'
      | '2'
      | '3'
    searchCondition.searchOption.searchMethodAnd.input = item.searchMethodAnd
    searchCondition.searchOption.searchMethodSynonym.input =
      item.searchMethodSynonym
    searchCondition.searchOption.searchMethodAllograph.input =
      item.searchMethodAllograph
    searchCondition.searchOption.andSearchType =
      item.searchType.length !== 0
        ? (item.searchType
            .split(',')
            .filter(
              (value, index, array) =>
                value !== '' && array.indexOf(value) === index
            ) as SearchType[])
        : []
    searchCondition.searchOption.andCollectionTarget =
      item.collectionTarget.length !== 0
        ? item.collectionTarget
            .split(',')
            .filter(
              (value, index, array) =>
                value !== '' && array.indexOf(value) === index
            )
        : []
    searchCondition.searchOption.andMaterialFormat.input = item.materialFormat
    searchCondition.searchOption.andBibliographyClass =
      item.bibliographyClass !== ''
        ? (item.bibliographyClass
            .split(',')
            .filter(
              (value, index, array) =>
                value !== '' && array.indexOf(value) === index
            ) as BibliographyClass[])
        : []
    searchCondition.basic.bibliography.title1.input = item.title1.replace(
      /(1$)|(2$)/,
      ''
    )
    searchCondition.basic.bibliography.title1.not =
      item.title1.slice(-1) === '2'
    searchCondition.basic.bibliography.title2.input = item.title2.replace(
      /(1$)|(2$)/,
      ''
    )
    searchCondition.basic.bibliography.title2.not =
      item.title2.slice(-1) === '2'
    searchCondition.basic.bibliography.titleInformation = item.titleInformation
    searchCondition.basic.bibliography.author1.input = item.author1.replace(
      /(1$)|(2$)/,
      ''
    )
    searchCondition.basic.bibliography.author1.no = item.author1No
    searchCondition.basic.bibliography.author1.not =
      item.author1.slice(-1) === '2' || item.author1No.slice(-1) === '2'
    searchCondition.basic.bibliography.author2.input = item.author2.replace(
      /(1$)|(2$)/,
      ''
    )
    searchCondition.basic.bibliography.author2.no = item.author2No
    searchCondition.basic.bibliography.author2.not =
      item.author2.slice(-1) === '2' || item.author2No.slice(-1) === '2'
    searchCondition.basic.bibliography.authorInformation =
      item.authorInformation
    searchCondition.basic.bibliography.subject1.input = item.subject1.replace(
      /(1$)|(2$)/,
      ''
    )
    searchCondition.basic.bibliography.subject1.no = item.subject1No
    searchCondition.basic.bibliography.subject1.not =
      item.subject1.slice(-1) === '2' || item.subject1No.slice(-1) === '2'
    searchCondition.basic.bibliography.subject2.input = item.subject2.replace(
      /(1$)|(2$)/,
      ''
    )
    searchCondition.basic.bibliography.subject2.no = item.subject2No
    searchCondition.basic.bibliography.subject2.not =
      item.subject2.slice(-1) === '2' || item.subject2No.slice(-1) === '2'
    searchCondition.basic.bibliography.series.input = item.series.replace(
      /(1$)|(2$)/,
      ''
    )
    searchCondition.basic.bibliography.series.no = item.seriesNo
    searchCondition.basic.bibliography.series.not =
      item.series.slice(-1) === '2' || item.seriesNo.slice(-1) === '2'
    searchCondition.basic.bibliography.completeWorks.input = item.completeWorks.replace(
      /(1$)|(2$)/,
      ''
    )
    searchCondition.basic.bibliography.completeWorks.no = item.completeWorksNo
    searchCondition.basic.bibliography.completeWorks.not =
      item.completeWorks.slice(-1) === '2' ||
      item.completeWorks.slice(-1) === '2'
    searchCondition.basic.bibliography.note.input = item.notes
    searchCondition.basic.bibliography.publisher.input = item.publisher.replace(
      /(1$)|(2$)/,
      ''
    )
    searchCondition.basic.bibliography.publisher.no = item.publisherNo
    searchCondition.basic.bibliography.publisher.not =
      item.publisher.slice(-1) === '2' || item.publisherNo.slice(-1) === '2'
    searchCondition.basic.bibliography.volumeLabel.input = item.volumeLabel.replace(
      /(1$)|(2$)/,
      ''
    )
    searchCondition.basic.bibliography.volumeLabel.not =
      item.volumeLabel.slice(-1) === '2'
    searchCondition.basic.bibliography.classNo.input = item.classNo
    searchCondition.basic.bibliography.publishedYearFrom.input =
      item.publishedYearFrom
    searchCondition.basic.bibliography.publishedYearTo.input =
      item.publishedYearTo
    searchCondition.basic.bibliography.freeWord.input = item.freeWords
    searchCondition.basic.bibliography.playbackTimeFrom.input =
      item.playbackTimeFrom !== 0 ? String(item.playbackTimeFrom) : ''
    searchCondition.basic.bibliography.playbackTimeTo.input =
      item.playbackTimeTo !== 0 ? String(item.playbackTimeTo) : ''
    searchCondition.basic.bibliography.volume.input = item.volume
    searchCondition.basic.bibliography.volumeNumber.input = item.volumeNumber
    searchCondition.basic.bibliography.volumeTotal.input = item.volumeTotal
    searchCondition.basic.bibliography.dateLabel.input = item.dateLabel
    searchCondition.basic.bibliography.genres.input = item.genre
    searchCondition.basic.bibliography.targetUsers.input = item.targetUsers
    searchCondition.basic.bibliography.targetUsersAv.input = item.targetUsersAv
    searchCondition.basic.collection.collectionTypes.input = item.collectionType
    searchCondition.basic.collection.shelfTypes.input = item.shelfType
    searchCondition.basic.collection.callNumberMark.input = item.mark
    searchCondition.basic.collection.callNumberNdc.input = item.ndc
    searchCondition.basic.collection.callNumberBook.input = item.book
    searchCondition.basic.collection.callNumberSub.input = item.sub
    searchCondition.basic.collection.traderCodes.input = item.traderCode
    searchCondition.basic.collection.donorCodes.input = item.donorCode
    searchCondition.basic.collection.collectionStatus.input =
      item.collectionStatus
    searchCondition.basic.collection.collectionStatus.collectionStatusRemove =
      item.collectionStatusRemove
    searchCondition.basic.collection.holdingBranchCodes.input =
      item.holdingBranchCode
    searchCondition.basic.collection.orderStatus.input = item.orderStatus
    searchCondition.basic.collection.orderBranchCodes.input =
      item.orderBranchCode
    searchCondition.basic.collection.acceptDateFrom.input = item.acceptDateFrom
    searchCondition.basic.collection.acceptDateTo.input = item.acceptDateTo
    searchCondition.basic.collection.handlingTypes.input = item.handlingType
    searchCondition.basic.collection.lendTotal.input =
      item.lendTotal !== 0 ? String(item.lendTotal) : ''
    searchCondition.basic.collection.lendTotalFlag.input = item.lendTotalFlag
    searchCondition.basic.collection.lastLendDate.input = item.lastLendDate
    searchCondition.basic.collection.lastLendDateFlag.input =
      item.lastLendDateFlag
    return searchCondition
  }
  if (item.type === '2') {
    searchCondition.searchType = 'alone'
    searchCondition.searchOption.displayMethod.input = item.displayMethod as
      | '1'
      | '2'
      | '3'
    if (item.newPublicationInformationDate !== '') {
      searchCondition.alone.searchType =
        AloneSearchType.NewPublicationInformationDate
      searchCondition.alone.newPublicationInformationDate.input =
        item.newPublicationInformationDate
    }
    if (item.newPublicationInformationVolume !== '') {
      searchCondition.alone.searchType =
        AloneSearchType.NewPublicationInformationVolume
      searchCondition.alone.newPublicationInformationVolume.input =
        item.newPublicationInformationVolume
    }
    if (item.collectionNo !== '') {
      searchCondition.alone.searchType = AloneSearchType.CollectionNo
      searchCondition.alone.collectionNo.input = item.collectionNo
      searchCondition.alone.collectionNo.exceptCheckDigit =
        item.exceptCheckDigit
    }
    if (item.orderId !== '') {
      searchCondition.alone.searchType = AloneSearchType.OrderId
      searchCondition.alone.orderId.input = item.orderId
    }
    if (item.bibliographyId !== '') {
      searchCondition.alone.searchType = AloneSearchType.Bibliography

      // DBの暗黙の仕様で「書誌階層 + ゼロパディングした書誌番号」が設定されているので、それを考慮した処理にする
      switch (item.bibliographyId.slice(0, 1)) {
        case Prefix.Real:
          searchCondition.alone.bibliographyId.bibliographyClass =
            BibliographyClass.Real
          searchCondition.alone.bibliographyId.input = String(
            Number(item.bibliographyId.slice(1))
          )
          break
        case Prefix.Set:
          searchCondition.alone.bibliographyId.bibliographyClass =
            BibliographyClass.Set
          searchCondition.alone.bibliographyId.input = String(
            Number(item.bibliographyId.slice(1))
          )
          break
        case Prefix.Content:
          searchCondition.alone.bibliographyId.bibliographyClass =
            BibliographyClass.Content
          searchCondition.alone.bibliographyId.input = String(
            Number(item.bibliographyId.slice(1))
          )
          break
        default:
          searchCondition.alone.bibliographyId.bibliographyClass =
            BibliographyClass.Real
          searchCondition.alone.bibliographyId.input = String(
            Number(item.bibliographyId)
          )
          break
      }
    }
    if (item.isbn !== '') {
      searchCondition.alone.searchType = AloneSearchType.Isbn
      searchCondition.alone.isbn.input = item.isbn
    }
    if (item.productNo !== '') {
      searchCondition.alone.searchType = AloneSearchType.ProductNumber
      searchCondition.alone.productNumber.input = item.productNo
    }
    if (item.magazineCode !== '') {
      searchCondition.alone.searchType = AloneSearchType.MagazineCode
      searchCondition.alone.magazineCode.input = item.magazineCode
    }
    if (item.marcNo !== '') {
      searchCondition.alone.searchType = AloneSearchType.Marc
      searchCondition.alone.marcType.input = item.marcNo.split('-')[0]
      searchCondition.alone.marcNo.input = item.marcNo
        .split('-')
        .slice(1)
        .join('-')
    }
    return searchCondition
  }
  if (item.type === '3') {
    searchCondition.searchOption.displayMethod.input = item.displayMethod as
      | '1'
      | '2'
      | '3'
    searchCondition.searchOption.searchMethodAnd.input = item.searchMethodAnd
    searchCondition.searchOption.searchMethodSynonym.input =
      item.searchMethodSynonym
    searchCondition.searchOption.searchMethodAllograph.input =
      item.searchMethodAllograph
    searchCondition.searchOption.andSearchType =
      item.searchType.length !== 0
        ? (item.searchType
            .split(',')
            .filter(
              (value, index, array) =>
                value !== '' && array.indexOf(value) === index
            ) as SearchType[])
        : []
    searchCondition.searchOption.andCollectionTarget =
      item.collectionTarget.length !== 0
        ? item.collectionTarget
            .split(',')
            .filter(
              (value, index, array) =>
                value !== '' && array.indexOf(value) === index
            )
        : []
    searchCondition.searchOption.andMaterialFormat.input = item.materialFormat
    searchCondition.searchOption.andBibliographyClass =
      item.bibliographyClass !== ''
        ? (item.bibliographyClass
            .split(',')
            .filter(
              (value, index, array) =>
                value !== '' && array.indexOf(value) === index
            ) as BibliographyClass[])
        : []
    searchCondition.free.freeWords.input = item.freeWords
    searchCondition.free.andKey.classNo.input = item.classNo
    searchCondition.free.andKey.collectionTypes.input = item.collectionType
    searchCondition.free.andKey.shelfTypes.input = item.shelfType
    searchCondition.free.andKey.callNumberMark.input = item.mark
    searchCondition.free.andKey.callNumberNdc.input = item.ndc
    searchCondition.free.andKey.callNumberBook.input = item.book
    searchCondition.free.andKey.callNumberSub.input = item.sub
    searchCondition.free.andKey.traderCodes.input = item.traderCode
    searchCondition.free.andKey.donorCodes.input = item.donorCode
    searchCondition.free.andKey.collectionStatus.input = item.collectionStatus
    searchCondition.free.andKey.collectionStatus.collectionStatusRemove =
      item.collectionStatusRemove
    searchCondition.free.andKey.holdingBranchCodes.input =
      item.holdingBranchCode
    searchCondition.free.andKey.orderStatus.input = item.orderStatus
    searchCondition.free.andKey.orderBranchCodes.input = item.orderBranchCode
    searchCondition.free.andKey.acceptDateFrom.input = item.acceptDateFrom
    searchCondition.free.andKey.acceptDateTo.input = item.acceptDateTo
    searchCondition.free.andKey.handlingTypes.input = item.handlingType
    searchCondition.free.andKey.lendTotal.input =
      item.lendTotal !== 0 ? String(item.lendTotal) : ''
    searchCondition.free.andKey.lendTotalFlag.input = item.lendTotalFlag
    searchCondition.free.andKey.lastLendDate.input = item.lastLendDate
    searchCondition.free.andKey.lastLendDateFlag.input = item.lastLendDateFlag
    return searchCondition
  }
  if (item.type === '4') {
    searchCondition.searchType = 'authority'
    if (item.author1 !== '' || item.author1No !== '') {
      searchCondition.authority.searchType = AuthoritySearchType.Author
      searchCondition.authority.author.input = item.author1
      searchCondition.authority.author.no = item.author1No
    }
    if (item.subject1 !== '' || item.subject1No !== '') {
      searchCondition.authority.searchType = AuthoritySearchType.Subject
      searchCondition.authority.subject.input = item.subject1
      searchCondition.authority.subject.no = item.subject1No
    }
    if (item.series !== '' || item.seriesNo !== '') {
      searchCondition.authority.searchType = AuthoritySearchType.Series
      searchCondition.authority.series.input = item.series
      searchCondition.authority.series.no = item.seriesNo
    }
    if (item.completeWorks !== '' || item.completeWorksNo !== '') {
      searchCondition.authority.searchType = AuthoritySearchType.CompleteWorks
      searchCondition.authority.completeWorks.input = item.completeWorks
      searchCondition.authority.completeWorks.no = item.completeWorksNo
    }
    if (item.contentAuthor !== '' || item.contentAuthorNo !== '') {
      searchCondition.authority.searchType = AuthoritySearchType.ContentAuthor
      searchCondition.authority.contentAuthor.input = item.contentAuthor
      searchCondition.authority.contentAuthor.no = item.contentAuthorNo
    }
    if (item.publisher !== '' || item.publisherNo !== '') {
      searchCondition.authority.searchType = AuthoritySearchType.Publisher
      searchCondition.authority.publisher.input = item.publisher
      searchCondition.authority.publisher.no = item.publisherNo
    }
    return searchCondition
  }
  if (item.type === '5') {
    searchCondition.searchType = 'content'
    searchCondition.searchOption.displayMethod.input = item.displayMethod as
      | '1'
      | '2'
      | '3'
    searchCondition.searchOption.searchMethodAnd.input = item.searchMethodAnd
    searchCondition.searchOption.searchMethodSynonym.input =
      item.searchMethodSynonym
    searchCondition.searchOption.searchMethodAllograph.input =
      item.searchMethodAllograph
    searchCondition.searchOption.andSearchType =
      item.searchType.length !== 0
        ? (item.searchType
            .split(',')
            .filter(
              (value, index, array) =>
                value !== '' && array.indexOf(value) === index
            ) as SearchType[])
        : []
    searchCondition.searchOption.andCollectionTarget =
      item.collectionTarget.length !== 0
        ? item.collectionTarget
            .split(',')
            .filter(
              (value, index, array) =>
                value !== '' && array.indexOf(value) === index
            )
        : []
    searchCondition.content.title.input = item.title1.replace(/(1$)|(2$)/, '')
    searchCondition.content.contentTitle.input = item.contentTitle.replace(
      /(1$)|(2$)/,
      ''
    )
    searchCondition.content.contentTitle.not =
      item.contentTitle.slice(-1) === '2'
    searchCondition.content.contentAuthor.input = item.contentAuthor.replace(
      /(1$)|(2$)/,
      ''
    )
    searchCondition.content.contentAuthor.id = item.contentAuthorNo
    searchCondition.content.contentAuthor.not =
      item.contentAuthor.slice(-1) === '2' ||
      item.contentAuthorNo.slice(-1) === '2'
  }

  return searchCondition
}
